(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ControllerController',ControllerController);

    ControllerController.$inject = ['$scope','$rootScope','$state','Controller','$uibModal','ToastrService','ControllerCustomService','ControllerGridDTO','SingleDblClickService']

    function ControllerController($scope, $rootScope, $state, Controller, $uibModal, ToastrService, ControllerCustomService, ControllerGridDTO, SingleDblClickService) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.refresh = refresh;
        vm.reset = reset;
        vm.reverse = true;
        vm.loadAll = loadAll;
        vm.toggleNeedsPayment = toggleNeedsPayment;

        vm.toggleOptions = [false, true];

        vm.addControllerPayment = addControllerPayment;

        function toggleNeedsPayment(value) {
            vm.filterModel.needsPayment = value;
            loadAll();
        }

        vm.gridOptions = {
            paginationPageSizes: [10,25,50,75,100],
            paginationPageSize: 100,
            enableRowSelection: true,
            enableSelectAll: false,
            enableFiltering: false,
            enableGridMenu: true,
            showGridFooter: true,
            useExternalPagination: true,
            rowTemplate: SingleDblClickService.rowTemplate(),
            onRegisterApi: function(gridApi) {
                gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
                    vm.page = newPage - 1;
                    loadAll()
                });
                gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
                    if(sortColumns && sortColumns.length > 0 && sortColumns[0]) {
                        vm.predicate = sortColumns[0].field;
                        vm.reverse = sortColumns[0].sort.direct === 'asc';
                    } else {
                        vm.predicate = 'id';
                        vm.reverse = true;
                    }
                    loadAll();
                });
                $scope.gridApi = gridApi;
            },
            enableColumnResizing: true,
            columnDefs: [
                {name:'Shipment', field:'shipment', visible: true},
                {name:'Invoice', field:'invoice', visible: true},
                {name:'Invoice Type', field:'invoiceType', visible: true},
                {name:'Controller', field:'controller', visible: true},
                {name:'Currency', field:'currency', visible: true},
                {name:'Amount', field:'amount', visible: true},
                {name:'Balance', field:'balance', visible: true}
            ]
        };

        initFilter();
        loadAll();
        // initFilterData();

        function initFilterData() {
            vm.shipments = [];
            ControllerCustomService.returnUsedShipments().then(function(data) {
                vm.shipments = data.data;
                vm.shipments.unshift({id:0, siNum:'Choose a Shipment'});
            }, function(error) {
                vm.shipments = [];
            });
            vm.invoices = [];
            ControllerCustomService.returnUsedInvoices().then(function(data) {
                vm.invoices = data.data;
                vm.invoices.unshift({id:0, invNum:'Choose an Invoice'});
            }, function(error) {
                vm.invoices = [];
            });
        }

        function initFilter() {
            vm.filterModel = {
                shipmentNum: '',
                invoiceNum: '',
                amountFrom: '',
                amountTo: '',
                controller: '',
                purchase: true,
                sale: true,
                japan: true,
                needsPayment: false
            }
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function refresh() {
            loadAll();
        }

        function reset() {
            vm.page = 0;
            vm.controllers = [];
            initFilter();
            // initFilterData();
            loadAll();
        }

        function loadAll() {
            if(vm.gridOptions) {
                vm.gridOptions.data = [];
            }
            vm.controllers = [];
            var queryParams = {
                page: vm.page,
                size: vm.gridOptions.paginationPageSize,
                sort: sort()
            };
            queryParams = Object.assign({}, queryParams, vm.filterModel);
            ControllerGridDTO.query(queryParams, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc':'desc')];
                if(vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.controllers = angular.copy(data);
                vm.gridOptions.data = vm.controllers;
                vm.gridOptions.totalItems = headers('X-Total-Count');
                $scope.gridApi.selection.clearSelectedRows();
                ToastrService.success("Successfully fetched Controller Payments","Success!");
            }

            function onError(error) {
                ToastrService.error("Failed to fetch Controller Payments", "Error");
            }
        }

        function addControllerPayment() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/controller/controller-dialog.html',
                controller: 'ControllerDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return {
                            id: null,
                            createdOn: new Date(),
                            createdBy: 'admin',
                            modifiedOn: new Date(),
                            modifiedBy: 'admin',
                            controller: null,
                            amount: 0,
                            balance: 0,
                            currency: 'USD',
                            amountDisplay: null,
                            shipment: null,
                            invoice: null
                        }
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('controller');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                reset();
                var data = {
                    heading: 'Detail ' + result.shipment.siNum,
                    route: 'controller.detail',
                    id: result.id,
                    param: {}
                };
                $rootScope.$emit('handleEmit', data);
                $state.go('controller.detail',{id: result.id}, {reload:true});
            });
        }

        $scope.rowSingleClick = function(row) {
            SingleDblClickService.singleClick(row, 'controller.detail', 'controller');
        };

        $scope.rowDblClick = function(row) {
            SingleDblClickService.dblClickModal(row, 'controller').result.then(function(result) {
                reset();
                var data = {
                    heading: 'Detail ' + result.shipment.siNum,
                    route: 'controller.detail',
                    id: result.id,
                    param: {}
                };
                $rootScope.$emit('handleEmit',data);
                $state.go('controller.detail',{id:result.id}, {reload:true});
            });
        };

        vm.createTab = function(data) {
            $scope.$emit('handleEmit',data);
        };

        vm.cleanFilter = function() {
            initFilter();
            reset();
        }
    }
})();
